// Mühendislik ve Mimarlık bölümleri (alfabetik)
// Kullanım: autocomplete önerisi. Kullanıcı serbest yazabilir (diğer bölümler için).
const ENGINEERING_DEPARTMENTS = [
  "Bilgisayar Mühendisliği",
  "Biyomedikal Mühendisliği",
  "Biyomühendislik",
  "Çevre Mühendisliği",
  "Deniz Ulaştırma İşletme Mühendisliği",
  "Elektrik Mühendisliği",
  "Elektrik-Elektronik Mühendisliği",
  "Elektronik Mühendisliği",
  "Elektronik ve Haberleşme Mühendisliği",
  "Endüstri Mühendisliği",
  "Endüstriyel Tasarım Mühendisliği",
  "Enerji Sistemleri Mühendisliği",
  "Gemi İnşaatı ve Gemi Makineleri Mühendisliği",
  "Gemi Makineleri İşletme Mühendisliği",
  "Gıda Mühendisliği",
  "Harita Mühendisliği",
  "Havacılık ve Uzay Mühendisliği",
  "İç Mimarlık",
  "İç Mimarlık ve Çevre Tasarımı",
  "İnşaat Mühendisliği",
  "İşletme Mühendisliği",
  "Jeodezi ve Fotogrametri Mühendisliği",
  "Jeofizik Mühendisliği",
  "Jeoloji Mühendisliği",
  "Kimya Mühendisliği",
  "Maden Mühendisliği",
  "Makine Mühendisliği",
  "Malzeme Bilimi ve Mühendisliği",
  "Mekatronik Mühendisliği",
  "Metalurji ve Malzeme Mühendisliği",
  "Meteoroloji Mühendisliği",
  "Mimarlık",
  "Nükleer Enerji Mühendisliği",
  "Orman Mühendisliği",
  "Orman Endüstri Mühendisliği",
  "Otomotiv Mühendisliği",
  "Petrol ve Doğal Gaz Mühendisliği",
  "Peyzaj Mimarlığı",
  "Raylı Sistemler Mühendisliği",
  "Su Ürünleri Mühendisliği",
  "Şehir ve Bölge Planlama",
  "Tekstil Mühendisliği",
  "Tıp Mühendisliği",
  "Uçak Mühendisliği",
  "Yapay Zeka Mühendisliği",
  "Yazılım Mühendisliği",
  "Ziraat Mühendisliği",
];

export { ENGINEERING_DEPARTMENTS };
